import {NgIf} from '@angular/common';
import {Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {NbActionsModule, NbTooltipModule} from '@nebular/theme';
import {GridGearComponent} from 'compob2b-libs';
import {translations} from '../../../../../environments/translations.ru';
import {ListComponent} from '../list.component';

@Component({
  selector: 'app-list-actions',
  standalone: true,
  imports: [
    GridGearComponent,
    NbActionsModule,
    NbTooltipModule,
    NgIf,
    RouterLink
  ],
  templateUrl: './list-actions.component.html',
  styleUrl: './list-actions.component.scss'
})
export class ListActionsComponent {
  @Input() list: ListComponent<any>;

  protected readonly translations = translations;
}
